import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PortalAdmin } from '../../models/portal-admin.model';
import { PortalAccessMatrixRowDTO } from '../../models/login-response.model';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  private tokenKey = 'token';
  private userKey = 'user';
  private accessKey = 'accessMatrix';
  private roleKeyName = 'roleKey';
  private roleNameKey = 'roleName';

  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    // if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(this.tokenKey);
    // }
    // return null;
  }

  setUser(user: any): void {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser(): PortalAdmin | null {
    const user = localStorage.getItem(this.userKey);
    return user ? JSON.parse(user) as PortalAdmin : null;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
    localStorage.removeItem(this.accessKey);
    localStorage.removeItem(this.roleKeyName);
    localStorage.removeItem(this.roleNameKey);
  }

  setAccessControl(accessMatrix: PortalAccessMatrixRowDTO[], roleKey: string, roleName: string): void {
    localStorage.setItem(this.accessKey, JSON.stringify(accessMatrix));
    if (roleKey) localStorage.setItem(this.roleKeyName, roleKey);
    if (roleName) localStorage.setItem(this.roleNameKey, roleName);
  }

  getAccessMatrix(): PortalAccessMatrixRowDTO[] {
    const raw = localStorage.getItem(this.accessKey);
    return raw ? JSON.parse(raw) as PortalAccessMatrixRowDTO[] : [];
  }

  getRoleKey(): string | null {
    return localStorage.getItem(this.roleKeyName);
  }

  getRoleName(): string | null {
    return localStorage.getItem(this.roleNameKey);
  }

  hasAccess(moduleKey: string, action: 'View' | 'Edit' | 'Add' | 'Review' = 'View'): boolean {
    const matrix = this.getAccessMatrix();
    const row = matrix.find(r => r.key === moduleKey);
    if (!row) return false;

    switch (action) {
      case 'View': return !!row.view;
      case 'Edit': return !!row.edit;
      case 'Add': return !!row.add;
      case 'Review': return !!row.review;
      default: return false;
    }
  }

  canView(moduleKey: string): boolean {
    return this.hasAccess(moduleKey, 'View');
  }

  canEdit(moduleKey: string): boolean {
    return this.hasAccess(moduleKey, 'Edit');
  }

  canAdd(moduleKey: string): boolean {
    return this.hasAccess(moduleKey, 'Add');
  }

  canReview(moduleKey: string): boolean {
    return this.hasAccess(moduleKey, 'Review');
  }
}
